import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { SectionTaxContainerService } from './section-tax-container.service';
import { TaxData } from '@fcp/lib-ui';

@Component({
  selector: 'fcp-section-tax-container',
  template: `
    <fcp-section-tax [tax]="data | async"></fcp-section-tax>
  `
})
export class SectionTaxContainerComponent implements OnInit {
  @Input() public id: string;
  public data: Observable<TaxData>;
  constructor(private sectionTaxContainerService: SectionTaxContainerService) {}

  ngOnInit() {
    this.data = this.sectionTaxContainerService.getTaxas(this.id);
  }
}
